import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import Modal from '../Modal';
import TicketStatus from '../Ticket_Status/TicketStatus';

const CustomerDashboard = () => {
  const [isTicketModalOpen, setIsTicketModalOpen] = React.useState(false);
  const location = useLocation();

  // Define the routes where the "Check Ticket Status" button should appear
  const allowedRoutes = [
    '/customer_dashboard',
    '/customer_dashboard/registered_product_details',
    '/customer_dashboard/awr/records'
  ];

  return (
    <div className="flex flex-col min-h-screen bg-[#FAF9FF]">
      <Navbar />

      {/* Main content with proper top spacing for fixed navbar */}
      <main className="flex-1 container mx-auto px-4 py-4 sm:px-6 md:px-8 lg:px-12 pt-16 sm:pt-18 md:pt-20">
        <Outlet />
        
        {/* Responsive "Track Repair Status" button */}
        {allowedRoutes.includes(location.pathname) && (
          <button
            onClick={() => setIsTicketModalOpen(true)}
            className="fixed 
                     bottom-4 left-4 
                     sm:bottom-6 sm:left-6 
                     md:bottom-8 md:left-8
                     bg-[#1C50A3] 
                     font-semibold 
                     text-white 
                     px-3 py-2 
                     sm:px-4 sm:py-2.5 
                     md:px-6 md:py-3
                     text-xs
                     sm:text-sm 
                     md:text-base
                     rounded-full 
                     shadow-lg 
                     hover:bg-[#144080]
                     focus:outline-none 
                     focus:ring-2 
                     focus:ring-[#1C50A3] 
                     focus:ring-opacity-50
                     transition-all 
                     duration-200 
                     transform 
                     hover:scale-105
                     active:scale-95
                     max-w-[120px]
                     sm:max-w-[140px]
                     md:max-w-none
                     leading-tight
                     z-30"
          >
            <span className="block sm:hidden">Track Status</span>
            <span className="hidden sm:block">Track Repair Status</span>
          </button>
        )}
      </main>

      {/* Responsive Modal */}
      <Modal 
        isOpen={isTicketModalOpen} 
        onClose={() => setIsTicketModalOpen(false)}
        className="w-full max-w-xs sm:max-w-md md:max-w-lg lg:max-w-xl"
      >
        <TicketStatus />
      </Modal>
    </div>
  );
};

export default CustomerDashboard;
